import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6b7b038"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增版本")
const _hoisted_2 = ["href"]
const _hoisted_3 = { style: {"white-space":"pre-wrap"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "查看", -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "删除", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Android")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("iOS")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("HarmonyOS")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("更新")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("不更新")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_UploadComponent = _resolveComponent("UploadComponent")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "版本管理",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setVisible(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'platform_code')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(text === 1 ? 'Android' : text === 2 ? 'iOS' : text === 3 ? 'HarmonyOS' : ''), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'package_url')
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: text,
              target: "_blank"
            }, _toDisplayString(text), 9, _hoisted_2))
          : _createCommentVNode("", true),
        (column.key === 'instruction')
          ? (_openBlock(), _createBlock(_component_a_popover, {
              key: 2,
              title: "更新内容",
              trigger: "click"
            }, {
              content: _withCtx(() => [
                _createElementVNode("p", _hoisted_3, _toDisplayString(text), 1)
              ]),
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (column.key === 'updatable')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(text ? '更新' : '暂不更新'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'control')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createElementVNode("a", {
                onClick: ($event: any) => (_ctx.setVisible(true, record)),
                style: {"margin-right":"10px"}
              }, "编辑", 8, _hoisted_5),
              _createVNode(_component_a_popconfirm, {
                title: "确定删除吗？",
                onConfirm: ($event: any) => (_ctx.delAppVersion(record))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visible) = $event)),
      title: "新增版本",
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setVisible(false))),
      confirmLoading: _ctx.loading,
      width: "700px",
      maskClosable: "false",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.formState,
          rules: _ctx.rules,
          "label-col": _ctx.labelCol,
          "wrapper-col": _ctx.wrapperCol
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              ref: "platform_code",
              label: "系统平台",
              name: "platform_code"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formState.platform_code,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.platform_code) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_a_radio, {
                      value: 1,
                      key: 1
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })),
                    (_openBlock(), _createBlock(_component_a_radio, {
                      value: 2,
                      key: 2
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })),
                    (_openBlock(), _createBlock(_component_a_radio, {
                      value: 3,
                      key: 3
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "version_name",
              label: "版本名称",
              name: "version_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.version_name,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.version_name) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "version_code",
              label: "版本号",
              name: "version_code",
              extra: "请输入纯数字，原则上递增"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.version_code,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.version_code) = $event)),
                  type: "number",
                  placeholder: "请输入"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "updatable",
              label: "是否更新",
              name: "updatable"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formState.updatable,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.updatable) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_a_radio, {
                      value: 1,
                      key: 1
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    })),
                    (_openBlock(), _createBlock(_component_a_radio, {
                      value: 0,
                      key: 2
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "package_url",
              label: "下载地址",
              name: "package_url"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.package_url,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.package_url) = $event)),
                  placeholder: _ctx.formState.platform_code === 2 ? '请输入' : '请输入或上传'
                }, null, 8, ["value", "placeholder"]),
                (_ctx.formState.platform_code === 1)
                  ? (_openBlock(), _createBlock(_component_a_form_item_rest, { key: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createVNode(_component_UploadComponent, {
                          ref: "fileUploadRef",
                          "on-change": _ctx.onFileChange,
                          "source-url": _ctx.formState.package_url,
                          type: "file",
                          "is-check-file": false
                        }, null, 8, ["on-change", "source-url"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "instruction",
              label: "更新内容",
              name: "instruction",
              placeholder: "请输入"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: _ctx.formState.instruction,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.instruction) = $event)),
                  placeholder: "请输入",
                  rows: 4
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              "wrapper-col": { span: 14, offset: 4 },
              style: {"margin-top":"16px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.onSubmit,
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"]),
                _createVNode(_component_a_button, {
                  style: {"margin-left":"10px"},
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setVisible(false))),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "label-col", "wrapper-col"])
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"])
  ], 64))
}